<template>
  <section>
    <div class="c-modal" :style="{display: show ? 'block' : 'none', 'z-index': 302}" v-if="shop">
      <div class="p-0 fixed" style="width: calc(100% - 30px);max-height: calc(100vh - 60px);">
        <div class="text-right" @click="closeModal()" v-show="!loading">
          <img src="/assets/images/icon/icon-close.svg" alt="" />
        </div>
        <div class="c-modal__dialog--center c-modal__content" v-show="!loading">
          <template>
            <div class="w-100 text-center">
              <img src="/assets/images/icon/icon-map-active.svg" class="mt-16" width="24" alt="" />
              <div class="mb-18 font-bold font-size-18 mt-13">
                {{ shop && shop.name }}
              </div>
              <div class="mb-30 font-bold"> {{ shop && shop.address }} </div>
              <div class="pt-32 border-top font-size-18 content-modal-auth font-bold">{{ isFollow() ? "表示店舗を変更しますか？" : "お気に入り登録しますか？" }}</div>
              <div v-if="isFollow()">
                <div class="btn-tutorial mt-32 mx-auto mb-24 font-size-18" @click.prevent="changeShop">
                  表示する
                </div>
                <div class="mx-auto mb-30 font-size-14 select-other-shop" @click.stop="onFavorite(shop)">
                  お気に入り店舗登録を解除する
                  <svg width="16" height="11" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.37891 9.24194L5.62155 4.9993" stroke="#FF7777" stroke-linecap="round"/>
                    <path d="M1.37891 0.756958L5.62155 4.9996" stroke="#FF7777" stroke-linecap="round"/>
                  </svg>
                </div>
              </div>
              <div v-else>
                <div class="mt-16">店舗は登録後に変更できます</div>
                <div class="btn-tutorial mt-16 mx-auto mb-16 font-size-16" @click.prevent="changeAndFollowShop" v-if="isChange">
                  お気に入り登録して表示する
                </div>
                <div class="btn-tutorial mt-16 mx-auto mb-16 font-size-16" @click.prevent="changeAndFollowShop" v-else>
                  登録して表示する
                </div>
                <div class="btn-tutorial outline mx-auto mb-10 font-size-16" @click.prevent="changeShop" v-if="isChange">
                  表示する
                </div>
                <div class="mx-auto mb-30 font-size-14 select-other-shop" v-if="isChange">
                  お気に入り登録せず切り替えられます
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <loader :loading="loading" />
  </section>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import store from "../store";
import { getShopFollows, updateShopFollows } from "../store/firestore";
import firebase from "../common/firebaseProject";
import Loader from "./parts/loader.vue";

export default Vue.extend({
  name: 'StoreSelectAlert',
  components: {
    Loader
  },
  store,
  props: ["shop", "isChange", "show", "onclose", "onFavoriteShop", "isFristTime"],
  data() {
    return {
      shop_follows: [],
      loading: false
    }
  },
  async created() {
    this.shop_follows = await getShopFollows(this.$store.state.userId);
  },
  methods: {
    // Record the number of SC items selected on the initial SC selection screen, by date and by SC.
    async countFirstTimeSelectShop() {
      if (this.isFristTime) {
        const callable = firebase.functions('asia-northeast1').httpsCallable('countFirstTimeSelectShop');
        await callable({
          shopId: this.shop.id,
          userId: this.$store.state.userId
        });
      }
      return;
    },
    async changeShop() {
      this.loading = true;
      await this.countFirstTimeSelectShop();
      this.$store.dispatch('setShopId', this.shop.id).then(() => {
        this.$router.push('/top');
      });
      this.loading = false;
    },
    async changeAndFollowShop() {
      this.loading = true;
      if (this.shop_follows.indexOf(this.shop.id) == -1) {
        const callable = firebase.functions('asia-northeast1').httpsCallable('subscribeTopic');
        await callable({
          topicId: `follow-store-${this.shop.id}`
        })
        this.shop_follows.push(this.shop.id);
        await updateShopFollows(this.shop_follows, this.$store.state.userId);
      }
      await this.countFirstTimeSelectShop();
      await this.$store.dispatch('setShopId', this.shop.id);
      this.$router.push('/top');
    },
    closeModal() {
      if (this.onclose) {
        this.onclose();
      }
    },
    isFollow() {
      return this.shop_follows.indexOf(this.shop.id) != -1;
    },
    async onFavorite(shop) {
      this.loading = true;
      await this.onFavoriteShop(shop);
      this.loading = false;
      this.closeModal();
    }
  }
})
</script>